import { Typography } from "@mui/material";
import moment from "moment";
import { FormattedDate } from "react-intl";

export const FormatDateTime = ({ value }) => {
  if (value) {
    const date = moment(value).toDate();
    if (isNaN(date.getTime())) {
      return (
        <Typography variant="body2" component="p">
          Invalid Date
        </Typography>
      );
    }
    return (
      <FormattedDate
        value={date}
        day="numeric"
        month="numeric"
        year="numeric"
      />
    );
  } else {
    return (
      <Typography variant="body2" component="p">
        -
      </Typography>
    );
  }
};
